module.exports = __webpack_public_path__ + "fonts/notosans-medium-web.e6e6d8f.woff";